function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.794 41.588c10.932 0 19.794-8.862 19.794-19.794S32.726 2 21.794 2 2 10.862 2 21.794s8.862 19.794 19.794 19.794z",
  stroke: "#fff",
  strokeWidth: "3.299",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.794 10.248v11.546H33.34",
  stroke: "#fff",
  strokeWidth: "3.299",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));